import React, { FC, useEffect } from "react";
import stl from "./index.module.scss";
import { SelectedPackage } from "../../store/selected/selectedPackages";
import { DefaultImage, Select } from "../../components";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";

type Data = SelectedPackage["supplementsServing"][0];
interface Props {
  data: Data;
  onSelect?: (v: number | null) => void;
}

const SupplementCard: FC<Props> = ({ data, onSelect }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.step_Checkout);
  const {
    name,
    quantity,
    servingActivityId,
    servingActivities,
    description,
    avatar,
  } = data;

  useEffect(() => {
    if (servingActivities.length === 1) {
      onSelect?.(servingActivities[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={stl.block}>
      <div className={stl.imgWrap}>
        {avatar ? (
          <img src={avatar} className={stl.img} alt="" />
        ) : (
          <DefaultImage className={stl.imgPlaceholder} />
        )}
      </div>
      <div className={stl.contentWrap}>
        <h3 className={stl.name}>
          {name} <i>x{quantity}</i>
        </h3>

        <p>{description}</p>

        <div className={stl.controls}>
          <Select
            placeholder={t("packageSupplementServing")}
            className={stl.selectServingActivity}
            value={servingActivityId ?? undefined}
            onChange={(v) => onSelect?.(v as number | null)}
          >
            {servingActivities.map(({ id, name }) => (
              <Select.Option key={name} value={id}>
                {name}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default SupplementCard;
